/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCombinationsWithRep } from '../../factoriesAny.js';
export var combinationsWithRepDependencies = {
  typedDependencies,
  createCombinationsWithRep
};